export default __webpack_public_path__ + "static/media/rippin.03f11891.jpg";